/**
 * Form Factor Audio — soft (pjax) navigation.
 *
 * Swaps only <main id="main-content"> on internal navigations so everything
 * outside it — the header, the footer, and crucially the Deacon voice widget —
 * stays mounted and the live call is never torn down. Re-runs window.FFAInitPage()
 * (theme.js) after each swap so product-page interactions keep working.
 *
 * Exposes window.softNavigate(url) for the Deacon copilot to use instead of a
 * hard window.location change.
 */
(function () {
  'use strict';
  var MAIN = 'main#main-content';

  function absOrigin(a) { return a.origin || (a.protocol + '//' + a.host); }

  function shouldPjax(a) {
    var href = a.getAttribute('href');
    if (!href) return false;
    if (a.target && a.target !== '' && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    if (href.indexOf('#') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return false;
    if (absOrigin(a) !== window.location.origin) return false;
    var p = a.pathname || '';
    if (p.indexOf('/checkout') === 0) return false;        // Shopify-hosted checkout
    if (p.indexOf('/cart/') === 0) return false;           // cart AJAX endpoints, not pages
    if (p.indexOf('/account') === 0) return false;         // login flows
    if (/\.(pdf|jpe?g|png|webp|gif|svg|zip|js|css|xml|txt|mp4|mov)$/i.test(p)) return false;
    return true;
  }

  var loadingBar;
  function bar() {
    if (loadingBar) return loadingBar;
    loadingBar = document.createElement('div');
    loadingBar.id = 'ffa-pjax-bar';
    document.body.appendChild(loadingBar);
    return loadingBar;
  }
  function setLoading(on) {
    var b = bar();
    if (on) { b.classList.remove('done'); b.classList.add('go'); }
    else { b.classList.add('done'); setTimeout(function () { b.classList.remove('go', 'done'); }, 300); }
  }

  var seq = 0;
  function swap(url, push) {
    var mine = ++seq;
    setLoading(true);
    return fetch(url, { headers: { 'X-Requested-With': 'ffa-pjax' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('pjax ' + r.status); return r.text(); })
      .then(function (html) {
        if (mine !== seq) return; // a newer navigation superseded this one
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newMain = doc.querySelector(MAIN);
        var cur = document.querySelector(MAIN);
        if (!newMain || !cur) { window.location.href = url; return; }
        cur.replaceWith(newMain);
        var t = doc.querySelector('title');
        if (t) document.title = t.textContent;
        // reflect canonical body template class (some styles key off it)
        if (doc.body && doc.body.className) document.body.className = doc.body.className;
        if (push) history.pushState({ ffaPjax: true }, '', url);
        window.scrollTo(0, 0);
        if (typeof window.FFAInitPage === 'function') { try { window.FFAInitPage(); } catch (e) {} }
        if (typeof window.FFARefreshCartCount === 'function') { try { window.FFARefreshCartCount(); } catch (e) {} }
        document.dispatchEvent(new CustomEvent('ffa:pjax', { detail: { url: url } }));
        setLoading(false);
      })
      .catch(function () { setLoading(false); window.location.href = url; });
  }

  // Public API for the Deacon copilot
  window.softNavigate = function (url) { return swap(url, true); };

  // Intercept internal link clicks
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a');
    if (!a || !shouldPjax(a)) return;
    // let in-page anchor links behave normally
    if (a.pathname === window.location.pathname && a.hash) return;
    e.preventDefault();
    if (a.href === window.location.href) return;
    swap(a.href, true);
  });

  // Back / forward
  window.addEventListener('popstate', function () { swap(window.location.href, false); });

  // Seed history state so the first Back after a pjax nav restores correctly
  try { history.replaceState({ ffaPjax: true }, '', window.location.href); } catch (e) {}
})();
